(function () {

  // Labor Day sale bar: a saving is applied.
  const saleTagMutedSvg = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9a8e82" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0l-7.2-7.2A2 2 0 0 1 2.8 12V4.8A2 2 0 0 1 4.8 2.8H12a2 2 0 0 1 1.4.6l7.2 7.2a2 2 0 0 1 0 2.8Z"/><circle cx="7.6" cy="7.6" r="1.4" fill="#9a8e82" stroke="none"/></svg>';
  const saleTagActiveSvg = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6b7c5e" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0l-7.2-7.2A2 2 0 0 1 2.8 12V4.8A2 2 0 0 1 4.8 2.8H12a2 2 0 0 1 1.4.6l7.2 7.2a2 2 0 0 1 0 2.8Z"/><circle cx="7.6" cy="7.6" r="1.4" fill="#6b7c5e" stroke="none"/></svg>';

  let latestShippingEligibleTotal = null;
  // Keep the cart so the sale bar can compute its own eligible total.
  let latestCart = null;
  let refreshTimer = null;
  let observerTimer = null;
  const productJsonCache = new Map();

  function formatMoney(cents) {
    const amount = Math.max(cents, 0) / 100;
    const currency = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'USD';

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
      maximumFractionDigits: cents % 100 === 0 ? 0 : 2
    }).format(amount);
  }

  function includesAny(value, needles) {
    const text = String(value || '').toLowerCase();
    return needles.some((needle) => text.includes(needle));
  }

  function isPackageProtectionItem(item) {
    if (!item) {
      return false;
    }

    const fields = [
      item.product_title,
      item.title,
      item.variant_title,
      item.vendor,
      item.product_vendor,
      item.product_type,
      item.handle,
      item.sku
    ];

    if (includesAny(fields.join(' '), ['package protection', 'redo'])) {
      return true;
    }

    const properties = item.properties || {};
    const propertyText = Array.isArray(properties)
      ? properties.map((property) => [property.name, property.value].join(' ')).join(' ')
      : Object.keys(properties).map((key) => [key, properties[key]].join(' ')).join(' ');

    return includesAny(propertyText, ['package protection', 'redo']);
  }

  function getLineItemTotal(item) {
    if (!item) {
      return 0;
    }

    if (typeof item.final_line_price === 'number') {
      return item.final_line_price;
    }

    if (typeof item.line_price === 'number') {
      return item.line_price;
    }

    if (typeof item.price === 'number' && typeof item.quantity === 'number') {
      return item.price * item.quantity;
    }

    return 0;
  }

  function getShippingEligibleTotal(cart) {
    if (!cart) {
      return 0;
    }

    if (!Array.isArray(cart.items)) {
      return typeof cart.total_price === 'number' ? cart.total_price : 0;
    }

    return cart.items.reduce((total, item) => {
      return total + (isPackageProtectionItem(item) ? 0 : getLineItemTotal(item));
    }, 0);
  }

  function updateShippingBars(shippingEligibleTotal) {
    latestShippingEligibleTotal = Number.isFinite(shippingEligibleTotal) ? shippingEligibleTotal : 0;
    updateSaleBars(latestShippingEligibleTotal);
  }

  // ---------------------------------------------------------------------------
  // Labor Day 2026 spend and save bar.
  //
  // Reads the cached cart total, so there is one fetch and one number. The ladder itself is not duplicated here: it is read from
  // the data-rungs attribute that snippets/cart-sale-progress.liquid prints,
  // which keeps Liquid the single source of truth for the offer.
  //
  // Inert when no sale bar is on the page.
  // ---------------------------------------------------------------------------

  function formatRemainingAmount(cents) {
    if (cents > 0 && cents < 100) {
      return 'less than $1';
    }

    return formatMoney(cents);
  }

  function parseSaleRungs(bar) {
    try {
      const parsed = JSON.parse(bar.dataset.rungs || '');

      if (Array.isArray(parsed) && parsed.length && Array.isArray(parsed[0])) {
        return parsed;
      }
    } catch (error) {
      // A malformed attribute leaves the server rendered message in place
      // rather than replacing it with something wrong.
    }

    return null;
  }

  // The four sale bar messages are merchant-editable in Theme settings and
  // arrive here as data attributes, so Liquid stays the single source of the
  // wording. Escape first, then insert markup, matching the Liquid order
  // exactly, so a stray angle bracket in a setting renders as a character.
  function escapeSaleText(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderSaleTemplate(template, fallback, values) {
    const raw = template && String(template).trim() ? template : fallback;

    return escapeSaleText(raw)
      .split('[amount]').join(`<strong>${values.amount}</strong>`)
      .split('[next]').join(values.next)
      .split('[saving]').join(values.saving);
  }

  function buildSaleMessage(bar, rungs, total) {
    let reached = 0;

    rungs.forEach((rung) => {
      if (total >= rung[0]) {
        reached += 1;
      }
    });

    const atTopRung = reached >= rungs.length;
    const currentSave = reached > 0 ? rungs[reached - 1][1] : 0;

    if (atTopRung) {
      return {
        reached,
        progress: 100,
        message: renderSaleTemplate(
          bar.dataset.msgTop,
          'Labor Day Sale - [saving] off applied.',
          { amount: '', next: '', saving: formatMoney(currentSave) }
        )
      };
    }

    const nextSpend = rungs[reached][0];
    const nextSave = rungs[reached][1];
    const segmentFloor = reached > 0 ? rungs[reached - 1][0] : 0;
    const remaining = Math.max(nextSpend - total, 0);
    const span = nextSpend - segmentFloor;
    const progress = span > 0
      ? Math.min(Math.max(((total - segmentFloor) / span) * 100, 0), 100)
      : 0;
    const remainingLabel = formatRemainingAmount(remaining);

    const values = {
      amount: remainingLabel,
      next: formatMoney(nextSave),
      saving: formatMoney(currentSave)
    };

    let message;

    if (reached > 0) {
      message = renderSaleTemplate(bar.dataset.msgProgress,
        '[saving] off applied. Spend [amount] more for [next] off.', values);
    } else if (total === 0) {
      message = renderSaleTemplate(bar.dataset.msgEmpty,
        'Spend [amount] for [next] off.', values);
    } else {
      message = renderSaleTemplate(bar.dataset.msgStart,
        'Spend [amount] more for [next] off.', values);
    }

    return { reached, progress, message };
  }

  // What the ladder counts. Must match what Shopify counts, or the bar promises
  // a rung the customer has not reached. The discounts are scoped to the
  // "Shop All Active" collection, and Shopify measures the minimum against the
  // items in that collection only. Package protection, the Rise.ai gift card
  // and both E-Design services sit outside it, so they are excluded here.
  // Mirrors the exclusion list in snippets/cart-sale-progress.liquid; change
  // both together, and add any future product that is not in that collection.
  function isSaleExcludedItem(item) {
    if (!item) {
      return false;
    }

    if (isPackageProtectionItem(item)) {
      return true;
    }

    const type = String(item.product_type || '').toLowerCase();

    return type.includes('gift card') || type.includes('e-design');
  }

  function getSaleEligibleTotal(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      return null;
    }

    return cart.items.reduce((total, item) => {
      return total + (isSaleExcludedItem(item) ? 0 : getLineItemTotal(item));
    }, 0);
  }

  function updateSaleBars(eligibleTotal) {
    const bars = document.querySelectorAll('[data-sm-cart-sale-progress]');

    if (!bars.length) {
      return;
    }

    const saleTotal = getSaleEligibleTotal(latestCart);
    const total = Number.isFinite(saleTotal)
      ? saleTotal
      : (Number.isFinite(eligibleTotal) ? eligibleTotal : 0);

    bars.forEach((bar) => {
      const rungs = parseSaleRungs(bar);

      if (!rungs) {
        return;
      }

      const state = buildSaleMessage(bar, rungs, total);
      const icon = bar.querySelector('[data-sm-cart-sale-icon]');
      const text = bar.querySelector('[data-sm-cart-sale-message]');
      const hasSaving = state.reached > 0;

      bar.dataset.cartTotal = String(total);
      bar.dataset.shippingEligibleTotal = String(total);
      bar.dataset.rungsReached = String(state.reached);
      bar.dataset.atTopRung = state.reached >= rungs.length ? 'true' : 'false';
      bar.dataset.cartEmpty = total === 0 ? 'true' : 'false';
      bar.style.setProperty('--sm-cart-shipping-progress', `${state.progress}%`);
      bar.classList.toggle('is-qualified', hasSaving);

      if (icon && icon.dataset.state !== (hasSaving ? 'saving' : 'none')) {
        icon.innerHTML = hasSaving ? saleTagActiveSvg : saleTagMutedSvg;
        icon.dataset.state = hasSaving ? 'saving' : 'none';
      }

      if (text && text.innerHTML !== state.message) {
        text.innerHTML = state.message;
      }
    });
  }

  function syncBarsFromMarkup() {
    const bars = document.querySelectorAll('[data-sm-cart-sale-progress]');
    if (!bars.length) {
      return;
    }

    const firstBar = bars[0];
    const total = Number(firstBar.dataset.shippingEligibleTotal || firstBar.dataset.cartTotal || 0);

    updateShippingBars(latestShippingEligibleTotal === null ? total : latestShippingEligibleTotal, false);
  }

  function refreshCart(allowAnimation = true) {
    window.clearTimeout(refreshTimer);

    refreshTimer = window.setTimeout(() => {
      fetch(`${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then((response) => (response.ok ? response.json() : null))
        .then((cart) => {
          if (cart && typeof cart.total_price === 'number') {
            latestCart = cart;
            updateShippingBars(getShippingEligibleTotal(cart), allowAnimation);
          }
        })
        .catch(() => {
          syncBarsFromMarkup();
        });
    }, 150);
  }

  function refreshCartAfterDeferredRendering() {
    [600, 1500, 3000].forEach((delay) => {
      window.setTimeout(() => refreshCart(false), delay);
    });
  }

  function shouldRefreshFromEventTarget(target) {
    return Boolean(
      target &&
      target.closest &&
      target.closest('cart-drawer, .cart-page, product-form, line-item-quantity, cart-discount-remove-button')
    );
  }

  function installPackageProtectionVisibilityOverride() {
    if (document.getElementById('sm-redo-cart-page-visibility-fix')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'sm-redo-cart-page-visibility-fix';
    style.textContent = [
      '.cart-page tr:has(.sm-cart-line-item--package-protection){display:table-row!important;visibility:visible!important;}',
      '.cart-page .sm-cart-line-item--package-protection{display:grid!important;visibility:visible!important;height:auto!important;opacity:1!important;}'
    ].join('');
    document.head.appendChild(style);
  }

  function revealCartPagePackageProtectionLines() {
    installPackageProtectionVisibilityOverride();

    document.querySelectorAll('.cart-page .sm-cart-line-item--package-protection').forEach((lineItem) => {
      lineItem.style.setProperty('display', 'grid', 'important');
      lineItem.style.setProperty('visibility', 'visible', 'important');
      lineItem.style.setProperty('height', 'auto', 'important');
      lineItem.style.setProperty('opacity', '1', 'important');

      const row = lineItem.closest('tr');

      if (row) {
        row.style.setProperty('display', 'table-row', 'important');
        row.style.setProperty('visibility', 'visible', 'important');
      }
    });
  }

  function normalizeOptionText(value) {
    return String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
  }

  function getProductJson(handle) {
    if (!handle) {
      return Promise.resolve(null);
    }

    if (productJsonCache.has(handle)) {
      return productJsonCache.get(handle);
    }

    const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    const productPromise = fetch(`${root}products/${encodeURIComponent(handle)}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then((response) => (response.ok ? response.json() : null))
      .catch(() => null);

    productJsonCache.set(handle, productPromise);

    return productPromise;
  }

  function findVariantImageForOption(product, optionPosition, label) {
    if (!product || !Array.isArray(product.variants) || !optionPosition || !label) {
      return null;
    }

    const optionKey = `option${optionPosition}`;
    const normalizedLabel = normalizeOptionText(label);
    const matchedVariant = product.variants.find((variant) => {
      return normalizeOptionText(variant && variant[optionKey]) === normalizedLabel && variant.featured_image && variant.featured_image.src;
    });

    return matchedVariant && matchedVariant.featured_image ? matchedVariant.featured_image.src : null;
  }

  function constrainShopifyImageWidth(src, width) {
    try {
      const imageUrl = new URL(src, window.location.origin);
      imageUrl.searchParams.set('width', String(width));
      return imageUrl.toString();
    } catch (error) {
      return src;
    }
  }

  function replaceFallbackSwatchWithThumbnail(label, imageSrc, labelText) {
    if (!label || !imageSrc || label.dataset.smVariantThumbnailFixed === 'true') {
      return;
    }

    label.classList.remove('block-swatch');
    label.classList.add('thumbnail-swatch', 'sm-js-variant-thumbnail');
    label.textContent = '';

    const srLabel = document.createElement('span');
    srLabel.className = 'sr-only';
    srLabel.textContent = labelText;

    const image = document.createElement('img');
    image.src = constrainShopifyImageWidth(imageSrc, 136);
    image.alt = '';
    image.loading = 'lazy';
    image.sizes = '(max-width: 699px) 48px, 68px';
    image.className = 'sm-variant-thumbnail__image';

    label.append(srLabel, image);
    label.dataset.smVariantThumbnailFixed = 'true';
  }

  function repairVariantThumbnailFallbacks() {
    document.querySelectorAll('variant-picker[handle]').forEach((picker) => {
      const fallbackLabels = [];

      picker.querySelectorAll('.variant-picker__option-values').forEach((container) => {
        if (!container.querySelector('.thumbnail-swatch')) {
          return;
        }

        container.querySelectorAll('label.block-swatch').forEach((label) => {
          fallbackLabels.push(label);
        });
      });

      if (!fallbackLabels.length) {
        return;
      }

      getProductJson(picker.getAttribute('handle')).then((product) => {
        if (!product) {
          return;
        }

        fallbackLabels.forEach((label) => {
          const input = label.htmlFor ? document.getElementById(label.htmlFor) : null;
          const optionPosition = input ? input.dataset.optionPosition : null;
          const labelText = label.textContent.trim().replace(/\s+/g, ' ');
          const imageSrc = findVariantImageForOption(product, optionPosition, labelText);

          if (imageSrc) {
            replaceFallbackSwatchWithThumbnail(label, imageSrc, labelText);
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    syncBarsFromMarkup();
    refreshCart(false);
    refreshCartAfterDeferredRendering();
    repairVariantThumbnailFallbacks();
    revealCartPagePackageProtectionLines();

    document.addEventListener('click', (event) => {
      if (shouldRefreshFromEventTarget(event.target)) {
        refreshCart(true);
        revealCartPagePackageProtectionLines();
      }
    });

    document.addEventListener('change', (event) => {
      if (shouldRefreshFromEventTarget(event.target)) {
        refreshCart(true);
        revealCartPagePackageProtectionLines();
      }
    });

    [
      'cart:change',
      'cart:refresh',
      'cart:update',
      'cart:updated',
      'cart:rerender',
      'line-item:change:end',
      'variant:add',
      'product:add'
    ].forEach((eventName) => {
      document.addEventListener(eventName, () => {
        refreshCart(true);
        revealCartPagePackageProtectionLines();
      });
    });

    new MutationObserver(() => {
      window.clearTimeout(observerTimer);
      observerTimer = window.setTimeout(() => {
        syncBarsFromMarkup();
        refreshCart(false);
        repairVariantThumbnailFallbacks();
        revealCartPagePackageProtectionLines();
      }, 80);
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
